import { DatePicker } from '@mui/x-date-pickers';
import { DateRange } from '@mui/icons-material';
import dayjs, { Dayjs } from 'dayjs';
import { useEntityHistoryControlsStyles } from './entity-history-timeline-controls.styles';

interface EntityHistoryTimelineControlsProps {
  pivotDate: Date;
  setPivotDate: (date: Date) => void;
}

export function EntityHistoryTimelineControls({ pivotDate, setPivotDate }: EntityHistoryTimelineControlsProps) {
  const classes = useEntityHistoryControlsStyles();

  const handleDateChange = (date: Dayjs | null) => {
    if (date) {
      const isToday = date.isSame(new Date(), 'day');
      setPivotDate(isToday ? new Date() : date.endOf('day').toDate());
    }
  };

  return (
    <div className={classes.wrapper}>
      <DatePicker
        className={classes.datePicker}
        value={dayjs(pivotDate)}
        onChange={handleDateChange}
        format="DD/MM/YYYY"
        disableFuture
        label="View from date"
        closeOnSelect
        slots={{ openPickerIcon: DateRange }}
        slotProps={{
          openPickerIcon: { className: classes.calendarIcon },
          popper: { style: { zIndex: 1500 } },
          textField: {
            variant: 'outlined',
            size: 'small'
          }
        }}
      />
    </div>
  );
}
